export const FALLEN_STAR = "/fallen_star";
export const FOUR_WORDS = "/four_words";
export const IMMORTALS = "/immortals";
export const INDIA_TRAVEL = "/india_travel";
export const LANDING = "/";